var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.s.mainContainer},[_c('EarnProductsHeader',{class:_vm.s.mb16}),(_vm.isProductsBlockVisible)?_c('div',{class:_vm.s.productsGrid},_vm._l((_vm.showedProducts),function(product,index){return _c('Product',{key:product.asset + String(index),attrs:{"product":product}})}),1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }